<div class="donut-container">
    <div class="items-container" *ngIf="!this.displayLoader">
        <div class="center-text-container">
            <div class="center-text">
                <div id="total-calls-text">{{this.totalCount | number:'1.0-0':'en-US'}}</div>
                <ng-container *ngIf="this.growthDateRangeAvailable">
                    <div *ngIf="!this.negativeGrowth;else growthLoss" id="total-calls-growth">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="13" viewBox="0 0 32 13" fill="none">
                            <path d="M8.04698 9.5C8.04698 9.77344 7.82161 10 7.5496 10H0.586249C0.314243 10 0.0888672 9.77344 0.0888672 9.5C0.0888672 9.36719 0.143268 9.24219 0.236528 9.14844L3.7182 5.64844C3.81146 5.55469 3.93581 5.5 4.06792 5.5C4.20004 5.5 4.32439 5.55469 4.41765 5.64844L7.89932 9.14844C7.99258 9.24219 8.04698 9.36719 8.04698 9.5Z" fill="#39B54A"/>
                        </svg>
                        <div style="position: absolute; left:15px;">
                            {{ (this.growth ?? 0) | number:'1.0-0':'en-US' }}%
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="header-container">
            <div id="chart-header">
                <h3 class="chart-title">{{this.title}}</h3>
            </div>
            <div *ngIf="serviceType!=ServiceMetricTypes.Findings && serviceType!=ServiceMetricTypes.CallsByReason" class="checkbox-container" >
                <input  id="line-chart-checkbox" #addServiceMetric type="checkbox" [checked]="checked" (change)="_onCheckedChange(addServiceMetric.checked)"> Add
            </div>
        </div>
        <div class="chart-container">
            <div class="donut-chart-container">
                <div echarts class="chart" [options]="chartOptions"></div>
            </div>
            
            <div class="line-chart-container">
                <div echarts class="lineChart" [options]="lineChartOptions"></div>
            </div>
        </div>
    </div>
    <loader [size]="'medium'" *ngIf="displayLoader"></loader>

    <ng-template #growthLoss>
        <div id="total-calls-loss">
            <svg style="transform:scale(1, -1);" xmlns="http://www.w3.org/2000/svg" width="32" height="13" viewBox="0 0 32 13" fill="none">
                <path d="M8.04698 9.5C8.04698 9.77344 7.82161 10 7.5496 10H0.586249C0.314243 10 0.0888672 9.77344 0.0888672 9.5C0.0888672 9.36719 0.143268 9.24219 0.236528 9.14844L3.7182 5.64844C3.81146 5.55469 3.93581 5.5 4.06792 5.5C4.20004 5.5 4.32439 5.55469 4.41765 5.64844L7.89932 9.14844C7.99258 9.24219 8.04698 9.36719 8.04698 9.5Z" fill="#DF3935"/>
            </svg>
            <div style="position: absolute; left:15px;">
                {{(this.growth ?? 0) | number:'1.0-0':'en-US'}}%
            </div>
        </div>
    </ng-template>
</div>




